import { AuthQueryKey } from '@/modules/auth/keys'
import { useSuspenseQuery } from '@tanstack/react-query'
import { getProfile } from '../../services/ProfileService'
import { UseBaseSuspenseQueryOptions } from '@/core/api/type'
import { GetAdminMeResponse } from '@/modules/admin/type'
import { GetOperatorMeResponse } from '@/modules/operator/type'

export default function useSuspenseQueryProfile(
	props?: UseBaseSuspenseQueryOptions<
		GetAdminMeResponse & GetOperatorMeResponse
	>,
) {
	return useSuspenseQuery({
		queryKey: [AuthQueryKey.Profile],
		queryFn: getProfile,
		staleTime: Infinity,
		...props,
	})
}
